import FilterGroup from "@/components/feature/FilterGroup";

export interface WorkFilterState {
  types: string[];
  years: string[];
  actressIds: string[];
}

interface WorkFiltersProps {
  state: WorkFilterState;
  onToggle: (key: keyof WorkFilterState, value: string) => void;
  onReset: () => void;
  typeOptions: { value: string; label: string; count: number }[];
  yearOptions: { value: string; label: string; count: number }[];
  actressOptions: { value: string; label: string; count: number }[];
}

export default function WorkFilters({
  state,
  onToggle,
  onReset,
  typeOptions,
  yearOptions,
  actressOptions,
}: WorkFiltersProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="mb-4 flex items-center justify-between">
        <h2 className="flex items-center gap-1.5 font-heading text-sm font-bold text-foreground-950">
          <i className="ri-equalizer-line text-primary-600" aria-hidden="true"></i>
          筛选作品
        </h2>
        <button
          type="button"
          onClick={onReset}
          className="cursor-pointer font-label text-[11px] text-foreground-500 transition-colors hover:text-primary-700"
        >
          全部重置
        </button>
      </div>
      <div className="grid gap-4 md:grid-cols-3">
        <FilterGroup
          title="作品类型"
          icon="ri-film-line"
          options={typeOptions}
          selected={state.types}
          onToggle={(value) => onToggle("types", value)}
        />
        <FilterGroup
          title="上映年份"
          icon="ri-calendar-line"
          options={yearOptions}
          selected={state.years}
          onToggle={(value) => onToggle("years", value)}
        />
        <div className="md:max-h-none">
          <h3 className="mb-2.5 flex items-center gap-1.5 font-label text-sm font-medium text-foreground-900">
            <i className="ri-user-star-line" aria-hidden="true"></i>
            主演女优
          </h3>
          <div className="flex max-h-[150px] flex-wrap gap-2 overflow-y-auto pr-1">
            {actressOptions.map((option) => {
              const active = state.actressIds.includes(option.value);
              return (
                <button
                  key={option.value}
                  type="button"
                  onClick={() => onToggle("actressIds", option.value)}
                  aria-pressed={active}
                  className={`inline-flex items-center gap-1 rounded-md border px-2.5 py-1.5 font-label text-xs transition-colors ${
                    active
                      ? "border-primary-500 bg-primary-500 text-background-50"
                      : "border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
                  }`}
                >
                  {option.label}
                  <span className={active ? "text-background-50/70" : "text-foreground-400"}>
                    {option.count}
                  </span>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}